import React from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Footer from "../../component/users/Footer";
import Sidebar from "../../component/users/Settings/Sidebar";
import Main from "../../component/users/Settings/Main";
import { useParams } from "react-router-dom";
import LoaderLayout from "../../component/users/LoaderLayout";

const Goals = () => {
  const user = useSelector((state) => state.user.loading);
  const urlparam = useParams();
  return (
    <>
      <Header />
      {user ? (
        <LoaderLayout />
      ) : (
        <Box className="userLayout settings">
          <Box
            sx={{
              display: "flex",
              gap: { xs: "15px", md: "25px" },
              // height: { md: "calc(100vh - 168px)", xs: "calc(100vh - 138px)" },
            }}
          >
            <Sidebar />
            <Main />
            <div style={{ width: "1px" }}></div>
          </Box>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default Goals;
